import { render, staticRenderFns } from "./introduces_new.vue?vue&type=template&id=07707c1e&scoped=true"
import script from "./introduces_new.vue?vue&type=script&lang=js"
export * from "./introduces_new.vue?vue&type=script&lang=js"
import style0 from "./introduces_new.vue?vue&type=style&index=0&id=07707c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07707c1e",
  null
  
)

export default component.exports